import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { teaserControlPoints } from 'appConstants';
import { TEditTeaserControlPoint } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IControlPointSelect {
	setControlPoint: (value: TEditTeaserControlPoint) => void;
}

const ControlPointSelect: React.FC<IControlPointSelect> = ({ setControlPoint }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectControlPoint') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return teaserControlPoints.map((el) => ({ id: el.id, name: tForm(el.name) }));
	}, [tForm]);

	return (
		<FormSelect
			testId="ControlPointSelect"
			name="selectedControlPoint"
			label="controlPointLabel"
			options={mappedOptions}
			onChange={setControlPoint}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ControlPointSelect);
